<template>
  <div>
    <b-card-actions
      :show-loading="saving || fetching"
      action-collapse
      action-refresh
      :title="$t('Lançamentos de Reserva de Fundos')"
      @refresh="getReservedFund"
    >
      <b-table
        ref="reconciliation-reservedFund-items-table"
        show-empty
        responsive
        striped
        class="bordered"
        :empty-text="getEmptyTableMessage($tc('RECONCILIATION_ITEM.NAME'), 'male')"
        :fields="fields"
        :items="reconciliationReservedFundItems"
      >
        <template #thead-top>
          <b-tr>
            <b-th
              variant="primary"
              colspan="6"
            >
              {{ $t('Transação Stripe') }}
            </b-th>
          </b-tr>
        </template>

        <template #cell(transactionId)="row">
          <span :title="row.item.description">{{
            row.item.transactionId
          }}</span>
        </template>

        <template #custom-foot>
          <tr>
            <th colspan="3" />
            <th class="text-right">
              {{ stripeTotalValue | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotalCommission | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotal | currency }}
            </th>
          </tr>
        </template>
      </b-table>

    </b-card-actions>
  </div>
</template>

<script>
import { BTable, BTr, BTh } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapState, mapGetters } from 'vuex'
import { reconciliationDomains } from '@/mixins'

export default {
  components: {
    BTable,
    BTr,
    BTh,
    BCardActions,
  },

  mixins: [reconciliationDomains],

  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('pages/financial/reconciliation/stripe/maintain', [
      'reconciliationReservedFundItems',
      'summaryReservedFundFields',
      'sorting',
    ]),

    ...mapGetters('app', ['paymentMethodsOptions']),

    stripeTotalValue() {
      return this.summaryReservedFundFields?.stripeTotalValue?.value
    },
    stripeTotalCommission() {
      return this.summaryReservedFundFields?.stripeTotalCommission?.value
    },
    stripeTotal() {
      return this.summaryReservedFundFields?.stripeTotal?.value
    },

    fields() {
      return [
        {
          label: this.$t('Reserva de Fundos'),
          key: 'transactionId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('NSU'),
          key: 'paymentMethodId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Transação'),
          key: 'paymentIntentId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Valor'),
          key: 'amount',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Comissão'),
          key: 'fee',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Liquido'),
          key: 'net',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        }
      ]
    }
  },

  mounted() {
  },

  methods: {
    getReservedFund() {
      this.$emit('get-data')
    },

    resetFiltersLocal() {
      this.getReservedFund()
    },
  },
}
</script>

<style></style>
